import { FiMenu } from "react-icons/fi";
import { HiOutlineUserCircle } from "react-icons/hi2";
import userProfile from "../../images/user-profile.svg";
import Logout from "../../images/log out.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import api from "../../api_interceptor/api";
import GenericModal from "./GenericModal";

const Header = ({ onMenuClick }) => {
  const navigate = useNavigate();
  const userData = useSelector((state) => state.user.userData);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogoutClick = () => {
    setShowLogoutModal(true);
  };

  const handleLogoutConfirm = async () => {
    setIsLoggingOut(true);
    try {
      await LogoutUser();

      // Clear client-side storage
      localStorage.clear();
      sessionStorage.clear();

      // Redirect to login
      navigate("/");
    } catch (error) {
      console.error("Logout error:", error);
      setIsLoggingOut(false);
      setShowLogoutModal(false);
      alert("Unable to logout. Please try again.");
    }
  };
 
  const LogoutUser = async () => {
    const response = await api.post(
      "api/logout",
      {},
      {
        headers: {
          "Content-Type": "application/json"
        }
      }
    );

    return response;
  };


  return (
    <>
      <header className="bg-primary flex justify-between py-3 px-4 text-white items-center">
        <button
          onClick={onMenuClick}
          className="p-1 rounded hover:bg-white/10 transition"
        >
          <FiMenu size={22} />
        </button>

        <div className="flex items-center gap-x-2">
          <img src={userProfile} alt="User Avatar" className="w-7 h-7 rounded-full object-cover" />
          <span className="text-[14px]">{userData?.FirstName} {userData?.LastName}</span>
          <img
            src={Logout}
            alt="Logout"
            className="w-6 h-6 cursor-pointer ml-2"
            onClick={handleLogoutClick}
          />
        </div>
      </header>

      <GenericModal
        open={showLogoutModal}
        title="Confirm Logout"
        description="Are you sure you want to logout?"
        primaryText="Yes, Logout"
        secondaryText="Cancel"
        loading={isLoggingOut}
        onPrimary={handleLogoutConfirm}
        onClose={() => !isLoggingOut && setShowLogoutModal(false)}
        disableBackdropClose={isLoggingOut}
      />
    </>
  );
};

export default Header;
